var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row front" }, [
    _vm.showFront
      ? _c(
          "div",
          {
            ref: "webcam_box",
            class: [
              "me-xl-0",
              "connection-box",
              "bottom-md",
              _vm.handleFrontClass,
            ],
            attrs: { name: "step4-check-front" },
          },
          [
            _c("div", { staticClass: "before" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-dark btn-lg icon icon-connection",
                  attrs: {
                    type: "button",
                    disabled: _vm.connectDisabled,
                    name: "connect-webcam",
                  },
                  on: { click: _vm.handelFrontConnected },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.reconnect
                          ? _vm.$t("preRegistration.step4.front.reconnect")
                          : _vm.$t("preRegistration.step4.front.connect")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "guide-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.reconnect
                        ? _vm.$t("preRegistration.step4.front.guide.reconnect")
                        : _vm.$t("preRegistration.step4.front.guide.connect")
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "after" }, [
              _c("div", { staticClass: "video-box" }, [
                _c("div", { staticClass: "text-item video-text" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("preRegistration.step4.front.ready"))),
                  ]),
                ]),
                _vm._v(" "),
                _vm.faceEvent
                  ? _c("video", {
                      ref: "front_mediapipe",
                      staticClass: "face_video reverse",
                      attrs: { autoplay: "", playsinline: "", muted: "" },
                      domProps: { muted: true },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.frontMonitoring
                  ? _c("video", {
                      staticClass: "face_video reverse",
                      attrs: {
                        autoplay: "",
                        playsinline: "",
                        muted: "",
                        id: "front_id",
                      },
                      domProps: { muted: true },
                    })
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cam-print-done" }, [
              _c("div", { staticClass: "icon-confirm" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("preRegistration.step4.front.connectComplete")
                    )
                  ),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.phase === 3
      ? _c(
          "div",
          { staticClass: "col-4 -box bottom-md" },
          [
            _c("div", { staticClass: "box -box top-md" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("preRegistration.step4.front.env"))),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "info" }, [
                _c("li", [
                  _c("b", [_vm._v("OS")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.userAgent.os.name ?? "-") +
                      " |\n          " +
                      _vm._s(_vm.userAgent.os.version ?? "-") +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [_vm._v("Browser")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.userAgent.browser.name ?? "-") +
                      " |\n          " +
                      _vm._s(_vm.userAgent.browser.version ?? "-") +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [_vm._v("Device")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.userAgent.device.vendor ?? "-") +
                      " |\n          " +
                      _vm._s(_vm.userAgent.device.model ?? "-") +
                      " |\n          " +
                      _vm._s(_vm.userAgent.device.type ?? "-") +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [_vm._v("Engine")]),
                  _vm._v(
                    _vm._s(_vm.userAgent.engine.name ?? "-") +
                      " |\n          " +
                      _vm._s(_vm.userAgent.engine.version ?? "-") +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [_vm._v("CPU")]),
                  _vm._v(_vm._s(_vm.userAgent.cpu.architecture ?? "-")),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("b", [_vm._v("Speed")]),
                  _vm._v(_vm._s(_vm.speed ?? "-")),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("Permission", { on: { handleDenied: _vm.handleDenied } }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }